import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

export function ScribbleBadge({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      component="span"
      sx={{
        position: "relative",
        display: "inline-block",
        px: 1.5,
        py: 0.5,
        lineHeight: 1,
        fontWeight: 800,
        color: "#724E41",
        whiteSpace: "nowrap",
        borderRadius: "999px",

        "&::before": {
          content: '""',
          position: "absolute",
          inset: "-13px -18px",
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          pointerEvents: "none",
          opacity: 0.95,

          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 200'%3E%3Cpath d='M30 105 C 90 15, 510 10, 570 95 C 540 200, 80 200, 30 105 Z' fill='none' stroke='%233B4A5A' stroke-width='10' stroke-linecap='round' stroke-linejoin='round' opacity='0.9'/%3E%3Cpath d='M45 105 C 110 30, 490 25, 555 95 C 525 185, 95 190, 45 105 Z' fill='none' stroke='%233B4A5A' stroke-width='6' stroke-linecap='round' stroke-linejoin='round' opacity='0.5'/%3E%3C/svg%3E\")",
        },

        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
